var map = {
	"./ba.json": 340,
	"./en.json": 4174,
	"./es.json": 6725,
	"./fr.json": 4605,
	"./hr.json": 6759,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./sl.json": 7110,
	"./sr.json": 8912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1266;